export default "__VITE_ASSET__f875972a__"